<template>
  <div :class="$style.noLegalStatusWarning">
    <strong>
      {{ $t('sandbox.warning') }}
    </strong>
  </div>
</template>

<style lang="scss" module>
.noLegalStatusWarning {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  background: var(--color-feedback-warning-400);

  @media (min-width: 768px) {
    font-size: var(--font-size-medium);
  }
}
</style>
